
import React from 'react';
import './contact.css';

import { Container, Row, Col } from 'reactstrap';
import Form from '../form/Form';

const Contact = () => {
  return (
    <section id='contact'>
        <Container>
            <Row>
                <Col lg='12' className='mb-5 cont'>
                    <h2>Get In Touch</h2>
                    <h6>We just want to hear from you, Please let us to know about you below down.</h6>
                </Col>

                <Col lg='6' md='6'>
                    <div className="contact-container d-flex align-items-center gap-5">
                        <div className="single-info__box w-50">
                            <h6>Address:</h6>
                            <p><a href="https://goo.gl/maps/LKNM8NDNJwnuX4hN7" target='_blank' rel='noreferrer'>Kampala, Nabulagala road, Uganda</a></p>
                        </div>
                        <div className="single-info__box w-50">
                            <h6>Phone:</h6>
                            <p><a href="Tel:+256706426800">+256 70 642 6800</a></p>
                        </div>
                    </div>
                    <div className="contact-container d-flex align-items-center gap-5">
                        <div className="single-info__box w-50">
                            <h6>Email:</h6>
                            <p><a href="mailto:powauinfo@gmail.com" target="_blank" rel='noreferrer'>powauinfo@gmail.com</a></p>
                        </div>
                        <div className="single-info__box w-50">
                            <h6>WhatsApp</h6>
                            <p><a href="https://api.whatsapp.com/send?phone=+256776050007" target='_blank' rel='noreferrer'>+256776050007</a></p>
                        </div>
                    </div>
                </Col>
                <Col lg='6'>
                    <Form />
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Contact